module.exports = __webpack_public_path__ + "img/51626511_S.d22f1bfc.png";